export const FUSION_TYPES = {
  GWI: 'gwi',
  MRI_SIMMONS: 'mri_simmons',
  TGI: 'tgi',
  WW_GWI_MED: 'ww_gwi_med',
} as const;

export const FUSION_LABELS = {
  MRI_SIMMONS: 'MRI-Simmons',
  GWI: 'GWI',
  TGI: 'TGI',
  WW_GWI_MED: 'Discover GWI',
} as const;

export const fusionTypeLabelMap = Object.entries(FUSION_TYPES).reduce(
  (acc, [fusionTypeKey, fusionTypeValue]) => {
    acc[fusionTypeValue] = FUSION_LABELS[fusionTypeKey];
    return acc;
  },
  {} as Record<string, string>
);
